import React from 'react';
import './HomeClose.css';
import { CUSTOMER_PORTAL_URL } from '../../constants/links';

const HomeClose = () => (
  <section className="gn-home-close" aria-labelledby="home-close-title">
    <div className="gn-container gn-home-close__inner">
      <h2 className="gn-home-close__title" id="home-close-title">
        Banking that stays with you.
      </h2>
      <p className="gn-home-close__text">
        Whether you’re spending or saving, GN Bank has the right place for your money.
      </p>
      <a
        className="btn btn-gn-primary"
        href={CUSTOMER_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Get started
      </a>
    </div>
  </section>
);

export default HomeClose;
